import { NgModule, Optional, SkipSelf } from '@angular/core';
import { throwIfAlreadyLoaded } from '@app/core/guards/module-import.guard';
import { HasAnyAuthorityDirective } from '@core/auth/has-any-authority.directive';
import { HideFromAnyAuthorityDirective } from '@core/auth/hide-from-any-authority.directive';

@NgModule({
    imports: [],
    exports: [
        HasAnyAuthorityDirective,
        HideFromAnyAuthorityDirective
    ],
    declarations: [
        HasAnyAuthorityDirective,
        HideFromAnyAuthorityDirective
    ],
    providers: [],
    schemas: []
})
export class CoreModule {
    constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}